import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { getAccessUser, verifyOneTimeLink } from "../Components/Api/headless";
import { useAppSelector } from "../redux-stores/hooks/hooks";
import {
  selectIsOneTime,
  selectOneTimeID,
} from "../redux-stores/reducers/PageState";
import {
  selectProlificExp,
  selectProlificUser,
  selectRunProlific,
} from "../redux-stores/reducers/ProlificExperiments";
import useXoltarNavigation from "./useXoltarNav";

export const useValidateProlific = () => {
  const runProlific = useAppSelector(selectRunProlific);
  const prolifcUser = useAppSelector(selectProlificUser);
  const prolifcExp = useAppSelector(selectProlificExp);
  const navigation = useXoltarNavigation();
  const [params, setSearchParams] = useSearchParams();
  console.debug(params);
  useEffect(() => {
    if (runProlific) {
      if (!prolifcUser || !prolifcUser.prolificId || !prolifcExp) {
        console.error("No prolific information");
        navigation("Error", new URLSearchParams({ type: "Prolific" }));
      } else {
        console.warn(
          "checking user access status with " +
            prolifcUser.prolificId +
            " " +
            prolifcExp
        );
        getAccessUser(prolifcUser.prolificId, prolifcExp).then((can_do) => {
          if (!can_do) {
            navigation("Error", new URLSearchParams({ type: "Prolific2" }));
          }
        });
        setSearchParams(
          new URLSearchParams({
            prolificID: prolifcUser.prolificId,
            prolificExp: prolifcExp,
            ...params,
          })
        );
      }
    }
    return () => {};
    // eslint-disable-next-line
  }, [runProlific, prolifcUser, prolifcExp, params]);
};

export const useValidateDemo = () => {
  const runDemo = useAppSelector(selectIsOneTime);
  const demoId = useAppSelector(selectOneTimeID);
  const navigation = useXoltarNavigation();
  const [params, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (runDemo) {
      if (!demoId) {
        navigation("Error", new URLSearchParams({ type: "Demo" }));
      } else {
        setSearchParams(
          new URLSearchParams({
            duid: demoId,
            ...params,
          })
        );
        verifyOneTimeLink(demoId)
          .then((isUsed) => {
            console.warn("The demo id is used", isUsed);
            if (isUsed) {
              navigation("Error", new URLSearchParams({ type: "Demo" }));
            }
          })
          .catch((err) => {
            console.error(err);
            navigation("Error", new URLSearchParams({ type: "Unknown" }));
          });
      }
    }
    return () => {};
    // eslint-disable-next-line
  }, [demoId, runDemo, params]);
};

export const useWebValidation = () => {
  useValidateDemo();
  useValidateProlific();
};
